import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"

const Wrapper = styled.div`
  .hero-splat {
    position: absolute;
    z-index: 1;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    @media (max-width: 900px) {
      svg {
        width: 450px;
        height: 450px;
      }
    }
    @media (max-width: 640px) {
      svg {
        width: 420px;
        height: 360px;
      }
    }
  }

  .hero-cup-image {
    position: relative;
    z-index: 10;
  }

  .hero-flair-image {
    &-1,
    &-2 {
      position: absolute;
      z-index: 2;
      left: 50%;
      top: 50%;

      @media (max-width: 900px) {
        height: 80px;
      }
      @media (max-width: 640px) {
        width: 80px;
        height: auto;
      }
    }

    &-1 {
      transform: translateY(20px) translateX(-335px) rotate(90deg);

      @media (max-width: 900px) {
        transform: translateY(12px) translateX(-240px) rotate(75deg);
      }
      @media (max-width: 640px) {
        transform: translateY(0px) translateX(-210px) rotate(80deg);
      }
    }
    &-2 {
      transform: translateY(-100px) translateX(160px);

      @media (max-width: 900px) {
        transform: translateY(60px) translateX(80px) rotate(100deg);
      }
      @media (max-width: 640px) {
        transform: translateY(60px) translateX(20px) rotate(150deg);
      }
    }

    &-3 {
      position: absolute;
      z-index: 1;
      left: 0;
      top: 35%;
      transform: translateX(-85px);

      @media (max-width: 900px) {
        transform: translateX(-50px);
        width: 110px;
      }
      @media (max-width: 640px) {
        transform: translateX(-50px);
      }
    }
  }
`

export default function StaticMilkshake(props) {
  const milkshakeImages = useStaticQuery(graphql`
    query StaticCupSplashmilkshakeImages {
      heroCup: file(relativePath: { eq: "milkshake/hero-cup.png" }) {
        childImageSharp {
          fluid(maxWidth: 376) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      flair1: file(relativePath: { eq: "milkshake/flair-01.png" }) {
        childImageSharp {
          fluid(maxWidth: 127) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      flair2: file(relativePath: { eq: "milkshake/flair-02.png" }) {
        childImageSharp {
          fluid(maxWidth: 134) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      mintLeaf: file(relativePath: { eq: "milkshake/mint-leaf.png" }) {
        childImageSharp {
          fluid(maxWidth: 169) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return (
    <Wrapper>
      <div className={`hero-splat`}>
        <svg
          width="739px"
          height="803px"
          viewBox="0 0 739 803"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <defs>
            <filter
              x="-2.8%"
              y="-2.5%"
              width="105.5%"
              height="105.1%"
              filterUnits="objectBoundingBox"
              id="filter-1"
            >
              <feOffset
                dx="0"
                dy="2"
                in="SourceAlpha"
                result="shadowOffsetOuter1"
              ></feOffset>
              <feGaussianBlur
                stdDeviation="4"
                in="shadowOffsetOuter1"
                result="shadowBlurOuter1"
              ></feGaussianBlur>
              <feColorMatrix
                values="0 0 0 0 0   0 0 0 0 0.152941176   0 0 0 0 0.247058824  0 0 0 0.0995957168 0"
                type="matrix"
                in="shadowBlurOuter1"
                result="shadowMatrixOuter1"
              ></feColorMatrix>
              <feMerge>
                <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
                <feMergeNode in="SourceGraphic"></feMergeNode>
              </feMerge>
            </filter>
          </defs>
          <path
            filter="url(#filter-1)"
            fill="#FEFEFE"
            d="m439.1 3.2161c4.2522-1.8801 9.0109-2.4005 13.668-2.2863 5.4385 0.13429 10.969 1.1516 15.659 3.8676 7.6139 4.4115 12.148 12.899 13.447 21.52 1.2984 8.6249-0.26173 17.421-2.5085 25.851-11.802 44.266-42.611 85.601-24.728 132.53 10.252 26.899 33.756 50.605 64.127 57.722 9.3134 2.1822 18.977 2.7966 28.586 3.1659 22.451 0.86618 46.163 0.17458 65.463-10.267 26.754-14.47 38.382-43.645 58.29-65.38 9.5242-10.398 24.776-19.811 38.42-14.383 9.3984 3.7434 14.354 13.755 13.878 23.055-0.47587 9.3031-5.4079 17.945-11.203 25.63-13.188 17.502-31.486 31.804-52.509 41.053-28.202 12.409-63.556 13.822-84.011 35.366-18.052 19.012-20.806 48.715-6.5092 70.195 7.359 11.056 18.467 19.711 26.095 30.615 7.6275 10.905 11.115 26.056 2.4031 36.266-3.8137 4.4719-9.5922 7.5237-12.505 12.519-5.639 9.6791 1.7641 21.339 1.1727 32.274-0.66962 12.439-11.747 22.511-23.821 28.443-12.07 5.9324-25.649 9.0278-37.628 15.111-31.506 16.004-46.995 50.94-45.813 83.684 1.8491 51.33 33.834 86.917 60.84 127.23 6.499 9.7026 12.628 19.996 14.803 31.428 2.1788 11.432-0.25833 24.32-8.841 32.287-9.6771 8.9842-25.802 9.5045-36.846 2.2192-19.718-13.006-16.496-44.088-20.36-64.517-5.0782-26.858-11.679-53.599-23.012-78.621-6.7981-15.007-15.697-29.846-29.857-39.757-14.16-9.9108-34.616-13.805-50.228-5.8887-11.727 5.9424-18.746 17.126-26.859 26.842-8.1102 9.716-19.63 19.022-33.025 18.133-14.276-0.9434-24.551-13.231-28.987-25.576s-5.0748-25.7-10.506-37.713c-5.4317-12.016-17.06-22.954-31.356-22.39-22.617 0.89304-45.483 9.5717-59.293 25.851-9.9728 11.757-14.657 26.493-23.362 39.052-8.7084 12.556-24.317 23.488-40.228 20.067-18.858-4.0556-26.333-26.818-18.974-43.084s24.456-26.973 41.214-35.806c10.316-5.4388 21.071-10.69 29.008-18.777 19.351-19.714 14.691-54.076-8.3651-70.181-12.247-8.5544-27.764-12.123-41.428-18.68-11.305-5.4288-21.581-13.184-27.648-23.4-6.0673-10.213-7.4303-23.075-1.7063-33.452 9.6839-17.555 35.082-22.87 48.457-38.307 13.362-15.413 10.693-40.244-5.6968-53.032-32.849-25.626-83.688-7.6547-121.57-11.086-6.8457-0.61774-14.089-2.0312-19.014-6.765-3.4025-3.2734-5.3195-7.8494-5.9688-12.499-1.9952-14.332 8.0388-28.54 21.346-34.584 13.307-6.0432 28.977-5.0662 42.927-0.65803s26.604 11.986 39.354 19.103c31.088 17.354 56.611 18.851 91.513 12.58 15.16-2.7261 30.751-3.5554 43.987-10.364 3.1067-1.5981 6.0843-3.5252 8.8919-5.882 16.013-13.436 23.838-38.733 13.063-56.886-10.354-17.448-33.243-27.13-48.991-39.301-12.114-9.3602-20.666-26.17-11.533-37.985 8.7696-11.344 28.865-10.236 40.836-1.6417 11.576 8.3082 17.644 21.181 23.737 33.424l0.63066 1.264c7.6343 15.252 16.302 30.075 25.935 44.363 27.43 40.68 77.876 11.21 102.63-16.709 35.221-39.727 15.646-100.32 25.945-147.97 2.5017-11.589 7.6241-24.035 18.572-28.88zm188.49 430.95c2.9845-2.1603 7.1243-1.7616 10.547-0.41911 6.0868 2.3818 11.055 7.5235 13.275 13.728 3.0619 8.5662 2.1322 16.376 8.6536 23.123 10.365 10.723 27.372 34.919 7.8586 47.121-4.2914 2.6816-9.7147 2.7089-14.687 1.8502-4.1601-0.72236-8.3976-2.1024-11.375-5.1281-6.4506-6.5456-4.4902-17.269-4.1803-26.506 0.37053-10.907-2.3074-21.906-7.6431-31.392-2.0278-3.605-4.4632-7.0737-5.5007-11.088-1.0341-4.0139-0.28632-8.8762 3.0518-11.289zm-596.3-14.113c13.121-2.7849 31.396 5.3757 33.845 16.88 2.4489 11.505-13.267 15.365-26.388 18.15-13.121 2.7849-24.331 2.3478-26.78-9.1567-2.4489-11.505 6.2026-23.088 19.324-25.873zm142.98-206.95c9.948-5.8564 28.547-2.9794 39.316-1.3804 6.7374 1.0011 11.232 4.1138 7.0768 12.362-2.8779 5.7129-12.227 11.863-17.963 14.091-7.4494 2.8872-15.451 5.9008-23.193 2.2107-9.4257-4.4931-16.735-20.514-5.2369-27.283z"
          ></path>
        </svg>
      </div>

      <div className={`hero-cup-image`}>
        <img
          alt="Milkshake!"
          src={milkshakeImages.heroCup.childImageSharp.fluid.src}
        />
      </div>

      <div className={`hero-flair-image-1`}>
        <img
          alt="Do you have enough flair?"
          src={milkshakeImages.flair1.childImageSharp.fluid.src}
        />
      </div>

      <div className={`hero-flair-image-2`}>
        <img
          alt="You can never have enough flair!"
          src={milkshakeImages.flair2.childImageSharp.fluid.src}
        />
      </div>

      <div className={`hero-flair-image-3`}>
        <img
          alt="More flair, more!"
          src={milkshakeImages.mintLeaf.childImageSharp.fluid.src}
        />
      </div>
    </Wrapper>
  )
}
